import type { SelectOption } from '@/shared/types';

import type { TagItem } from '@/entities/tags';
import { updateEntityTags } from '@/entities/tags/api';

export const updateGlossaryCategoryTags = async (
  glossaryCategoryId: string,
  newTagFQNs: string[],
  availableTags: SelectOption<string>[],
  currentTags: TagItem[]
): Promise<void> => {
  await updateEntityTags(`/glossaries/${glossaryCategoryId}`, newTagFQNs, availableTags, currentTags);
};
